// Time period enum
export enum TimePeriod {
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

// Query parameters for insights API
export interface InsightsQuery {
  period?: TimePeriod;
  startDate?: string;
  endDate?: string;
  selectedYear?: number;
  selectedQuarter?: string;
  selectedMonth?: string;
}

// Monthly data point base interface
export interface MonthlyDataPoint {
  month: string;
  year: number;
  value: number;
}

// Opt-in rate specific data point
export interface OptInRateDataPoint extends MonthlyDataPoint {
  isCurrentMonth?: boolean;
  optIns: number;
  totalAdoptions: number;
  optInRate: number | null;
  isPastMonth: boolean;
  hasZeroOptIns: boolean;
  reportMissing?: boolean;
  isFirstReportDueMonth?: boolean;
  isZeroZeroState?: boolean;
  isMissedMonth?: boolean;
}

// Adoption specific data point
export interface AdoptionDataPoint extends MonthlyDataPoint {
  adultDogs: number;
  puppies: number;
  adultCats: number;
  kittens: number;
  total: number;
  reportMissing?: boolean;
  isPastMonth?: boolean;
}

// Opt-in rate insights
export interface OptInRateInsights {
  overallOptInRate: number | null;
  totalOptIns: number;
  totalAdoptions: number;
  programTarget: number;
  monthlyData: OptInRateDataPoint[];
  period: string;
  statusMessage: string;
  hasCompleteData: boolean;
  hasOptInData: boolean;
  hasAdoptionData: boolean;
}

// Adoptions insights
export interface AdoptionsInsights {
  totalAdoptions: number;
  totalAdultDogs: number;
  totalPuppies: number;
  totalAdultCats: number;
  totalKittens: number;
  monthlyData: AdoptionDataPoint[];
  period: string;
  statusMessage: string;
  hasCompleteData: boolean;
  hasAdoptionData: boolean;
}

// Dashboard insights combining both
export interface DashboardInsights {
  optInRate: OptInRateInsights;
  adoptions: AdoptionsInsights;
  lastUpdated: string;
  complianceWarning?: {
    show: boolean;
    daysSinceLastData: number | null;
  } | null;
  lastDataReceivedDate?: string;
}

// Loading state interface
export interface InsightsLoadingState {
  isLoading: boolean;
  isRefreshing: boolean;
  error: string | null;
}

export interface ChartDataPoint {
  month: string;
  year: number;
  [key: string]: number | string | boolean | null | undefined;
}

export interface ChartSeries {
  key: string;
  color: string;
  label: string;
}
